import React from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  styled,
} from "@material-ui/core";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Cancel from "@material-ui/icons/Cancel";
const TreeItemNode = ({
  node,
  selectedCodes,
  setSelectedCodes,
  level = 0,
  parentMap = {},
}) => {
  const isChecked = !selectedCodes?.has(node?.code);
  const handleChange = (e) => {
    const checked = e.target.checked;
    const updatedCodes = new Set(selectedCodes);

    // ✅ Toggle the node and all its children
    const toggleNodeAndChildren = (n) => {
      if (!checked) {
        updatedCodes.add(n.code);
      } else {
        updatedCodes.delete(n.code);
      }

      if (n.children?.length) {
        n.children.forEach(toggleNodeAndChildren);
      }
    };

    // ✅ Update all parent nodes recursively
    const updateParentSelection = (child) => {
      const parent = parentMap[child.code];
      if (!parent) return;
      const allChildrenDisabled = parent.children.every((child) =>
        updatedCodes.has(child.code)
      );

      if (allChildrenDisabled) {
        updatedCodes.add(parent.code);
      } else {
        updatedCodes.delete(parent.code);
      }

      updateParentSelection(parent); // Keep climbing up
    };
    toggleNodeAndChildren(node);
    updateParentSelection(node);

    setSelectedCodes(updatedCodes);
  };

  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-switchBase": {
      // padding: 10,
      "&.Mui-checked": {
        transform: "translateX(22px)",
        color: "#4caf50",
        "& + .MuiSwitch-track": {
          backgroundColor: "#c8e6c9",
          opacity: 1,
        },
        "& .MuiSwitch-thumb": {
          backgroundColor: "#4caf50",
          "&:before": {
            content: '""',
            position: "absolute",
            width: "100%",
            height: "100%",
            padding: 10,
            backgroundImage: `url("data:image/svg+xml;utf8")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          },
        },
      },
      "& .MuiSwitch-thumb": {
        backgroundColor: "#f44336",
        "&:before": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundImage: `url("data:image/svg+xml;utf8")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: 20,
      height: 20,
      position: "relative",
    },
    "& .MuiSwitch-track": {
      borderRadius: 20,
      backgroundColor: "#e0e0e0",
      opacity: 1,
    },
  }));

  const margin = `${level * 40}px`;

  return (
    <>
      <Box
        sx={{
          position: "relative",
          ml: level * 3,
          pl: 2,
          borderLeft: level > 0 ? "2px dashed #000000" : "none",
          marginLeft: margin,
          marginTop: level === 0 ? "20px" : "0px",
          "&::before": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: 0,
            width: 12,
            borderTop: level > 0 ? "2px dashed #000000" : "none",
          },
        }}
      >
        <Box display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Android12Switch
                checked={isChecked}
                onChange={handleChange}
                name="checkedB"
                color="primary"
              />
            }
            label={
              <Typography
                style={{
                  color: "#000000",
                  fontWeight: level === 0 ? 700 : 400,
                  textDecoration: level === 0 ? "underline" : "none",
                  fontSize: level === 0 ? "18px" : "16px",
                }}
              >
                {node.name}
              </Typography>
            }
          />
        </Box>
      </Box>

      {node.children?.map((child) => (
        <TreeItemNode
          key={child?.code}
          node={child}
          selectedCodes={selectedCodes}
          setSelectedCodes={setSelectedCodes}
          level={level + 1}
          parentMap={parentMap}
        />
      ))}
    </>
  );
};

export default TreeItemNode;
